(function () {
  'use strict';
  angular.module('vcpatdocs')
    .component('timeslip', {
      restrict: 'E',
      bindings: {
      },
      template: `
        <h3>Zeitbestätigung</h3>
        <form class="form-vertical"  id="timeform" name="timeform">
        <!-- Überweisung für: -->
          <div class="form-group">
            <!-- Patientensuche -->
            <label for="reffor">Patient</label>
            <div class="form-group  col-xs-12" ng-hide="vm.timeslip.patientid">
              <clientsearch id="patient" parentsave="vm.savePatient(client, mode)" mode="patient"></clientsearch>
            </div>
            <div class="form-group col-xs-12" ng-show="vm.timeslip.patientid">
              <div class="input-group">
                <input type="text" class="form-control"
                       id="patientname"
                       tabindex="0"
                       readonly
                       ng-model="vm.timeslip.patient.fname">
                <span class="input-group-btn">
                  <button class="btn btn-danger"
                          ng-click="vm.clearPatient()"><i class="fa fa-remove"></i>
                  </button>
                </span>
              </div>
            </div>
          </div>
        
        <!-- Datum: -->
          <div class="form-group">
            <label for="tdate">Datum</label>
              <input type="text" class="form-control"
                     id="tdate"
                     tabindex="0"
                     ng-model="vm.timeslip.date">
          </div>
          
        <!-- Zeit: -->
          <div class="form-group">
            <label for="tfrom">Von</label>
              <input type="text" class="form-control"
                     id="tfrom"
                     tabindex="0"
                     ng-model="vm.timeslip.fromtime">
          </div>
            
          <div class="form-group">
            <label for="tto">Bis</label>
              <input type="text" class="form-control"
                     id="tto"
                     tabindex="0"
                     ng-model="vm.timeslip.totime">
          </div>
        
          <!-- Buttons -->
          <divclass="spacer-bottom ">
            <button class="btn btn-success" ng-disabled="timeform.$invalid" type="button" ng-click="vm.print();"
                    tabindex="0">
              Drucken
            </button>
          </div>
          <div class="alert alert-success" ng-show="vm.printed === true"><i class="fa fa-check"></i> Zeitbestätigung erfolgreich
            gedruckt
          </div>
          <div class="alert alert-danger" ng-show="vm.printed === false"><i class="fa fa-warning"></i> Druck der Zeitbestätigung
            fehlgeschlagen
          </div>
        </form>
`,
      controllerAs: 'vm',
      controller: ['$log', 'Patdocs', 'ClientHelper', 'Config', 'Rlog', '$timeout', 'PrintHelper',
        function ($log, Patdocs, ClientHelper, Config, Rlog, $timeout, PrintHelper) {
          let vm = this;

          vm.savePatient = savePatient;
          vm.clearPatient = clearPatient;

          vm.add = add;
          vm.cancel = cancel;
          vm.print = print;

          vm.options = {updateOn: 'default blur', debounce: {default: 20000, blur: 0}};

          vm.$onInit = function () {
            vm.mode = 'patient';
            inittimeslip();
          }; // $onInit()

          // reset timeslip form
          function inittimeslip() {
            vm.timeslip = {};
            vm.timeslip.type = 'timeslip';
            vm.timeslip.date = moment().locale('de-at').format('ll');
            vm.timeslip.fromtime = moment().subtract(53, 'minutes').format('HH:mm');
            vm.timeslip.totime = moment().add(5, 'minutes').format('HH:mm');
          }

          // save patient data
          function savePatient(client, mode) {
            $log.debug('patient in savePAtient: ', client, mode);
            delete vm.timeslip.patient;
            vm.patient = client;
            vm.patientid = client._id;
            vm.timeslip.patient = {};
            vm.timeslip.patient.fname = vm.patient.primarycontact.firstname + ' ' + vm.patient.primarycontact.lastname;
            vm.timeslip.patient.svdata = vm.patient.svdata;
            vm.timeslip.patientid = vm.patient._id;
            vm.timeslip.patient._id = vm.patient._id;
            vm.timeslip.patient.primarycontact = vm.patient.primarycontact;
          }

          // clear timelip patient
          function clearPatient() {
            delete vm.timeslip.patient;
            delete vm.timeslip.patientid;
          }


          function add() {
            Patdocs.$create(vm.timeslip).$then(function () {
              vm.saved = true;
              vm.savefailed = false;
              vm.canceled = false;
              inittimeslip();
              $timeout(function () {
                vm.saved = false;
              }, 3000);
            });
          }

          function cancel() {
            vm.saved = false;
            vm.canceled = true;
            vm.savefailed = false;
            inittimeslip();
            $timeout(function () {
              vm.canceled = false;
            }, 3000);
          }

          function print() {
            Patdocs.$create(vm.timeslip).$then(function (timeslip) {
              vm.saved = true;
              vm.savefailed = false;
              vm.canceled = false;
              $timeout(function () {
                vm.saved = false;
              }, 3000);
              inittimeslip();
              $log.debug('timelip returned: ', timeslip);
              PrintHelper.jsonPrint(vm.patientid, 'time', timeslip).then(function () {
                $log.debug('printing timeslip succeeded');
                vm.printed = true;
                $timeout(function () {
                  delete vm.printed;
                }, 3000);
              }, function (err) {
                vm.printed = false;
                $timeout(function () {
                  delete vm.printed;
                }, 3000);
                $log.error('printing timeslip failed: ', err);
              });

            });
          }

        }
      ] // controller
    }); // component

// klammerfriedhof
}());
